import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import Button from '@material-ui/core/Button';
import RenderFileInput from "../inputs/renderFileField";

const ScoreRecordFileForm =  (props) =>{
  const {submitFile, handleSubmit, handleCancel} = props;
  return (
    <form onSubmit={handleSubmit(submitFile)}>
      <div className={'form-group'}>
        <Field name="file" label={'Select File'} component={RenderFileInput} required fullWidth type={'file'}>
        </Field>
      </div>
      <div className={'form-group'}>
        <Button type={'submit'} variant="contained" color="primary" className={'mr-3'}>
          {'Upload'}
        </Button>
        <Button onClick={handleCancel} variant="contained" color="secondary">
          {'Cancel'}
        </Button>
      </div>
    </form>
  )

};

export default reduxForm({
  enableReinitialize: true,
  form: 'scoreRecordFileForm',
})(ScoreRecordFileForm);



// WEBPACK FOOTER //
// ./src/components/scoreRecord/scoreRecordFileForm.js